// presentingComplaintOptions.js

const presentingComplaintOptions = {
  'Trauma & Injuries': [
    { label: 'Fall', keywords: ['fall', 'fallen', 'trip'] },
    { label: 'Fall (No Injury / Not Injured)', keywords: ['fall', 'not injured', 'no injury', 'no injuries', 'lift assist'] },

    { label: 'Head Injury', keywords: ['head', 'head injury', 'hi', 'concussion', 'hit head'] },
    { label: 'Spinal Injury', keywords: ['spine', 'spinal', 'neck injury', 'back injury', 'c-spine'] },

    { label: 'Traumatic Injury', keywords: ['trauma', 'injury'] },
    { label: 'Road Traffic Collision', keywords: ['rtc', 'rta', 'car crash', 'collision'] },

    { label: 'Assault', keywords: ['assault', 'fight', 'violence', 'punched'] },
    { label: 'Burns', keywords: ['burn', 'scald'] },
    { label: 'Bleeding', keywords: ['bleeding', 'haemorrhage', 'hemorrhage', 'blood loss'] },

    { label: 'Laceration / Cut', keywords: ['cut', 'laceration', 'wound', 'gash'] },
    { label: 'Sprain / Strain', keywords: ['sprain', 'strain', 'twisted', 'pulled'] },
    { label: 'Fracture / Suspected Fracture', keywords: ['fracture', 'broken', 'break'] },
    { label: 'Dislocation', keywords: ['dislocation', 'dislocated'] },
    { label: 'Crush Injury', keywords: ['crush', 'trapped'] },
    { label: 'Amputation', keywords: ['amputation', 'severed'] },

    { label: 'Animal or Insect Bite / Sting', keywords: ['bite', 'stung', 'sting', 'wasp', 'bee', 'dog bite'] },
    { label: 'Foreign Body', keywords: ['foreign body', 'fb', 'something stuck', 'splinter'] },
    { label: 'Eye Injury', keywords: ['eye injury', 'eye trauma', 'foreign body eye'] },
    { label: 'Facial Injury', keywords: ['face injury', 'facial', 'nose injury', 'jaw'] },

    { label: 'Drowning', keywords: ['drowning', 'submersion', 'near drowning'] },
    { label: 'Electrocution', keywords: ['electric shock', 'electrocution'] },
  ],

  Cardiorespiratory: [
    { label: 'Chest Pain', keywords: ['chest pain', 'cp', 'chest', 'tight chest', 'pressure'] },
    { label: 'Shortness of Breath', keywords: ['sob', 'breathless', 'difficulty breathing', 'cant breathe', "can't breathe"] },
    { label: 'Palpitations', keywords: ['palpitations', 'fast heart', 'racing heart', 'fluttering'] },

    { label: 'Cough', keywords: ['cough'] },
    { label: 'Wheezing', keywords: ['wheeze', 'wheezing'] },
    { label: 'Chest Infection', keywords: ['chest infection', 'lri', 'pneumonia', 'productive cough'] },

    { label: 'Asthma Exacerbation', keywords: ['asthma', 'wheeze', 'inhaler', 'tight chest'] },
    { label: 'COPD Exacerbation', keywords: ['copd', 'breathless', 'wheeze', 'sputum'] },

    { label: 'Choking', keywords: ['choking', 'airway obstruction', 'food stuck'] },
    { label: 'Respiratory Arrest', keywords: ['resp arrest', 'not breathing', 'apnoea', 'apnea'] },
    { label: 'Cardiac Arrest', keywords: ['cardiac arrest', 'arrest', 'cpr', 'no pulse'] },
  ],

  Neurological: [
    { label: 'Collapse / Syncope', keywords: ['collapse', 'syncope', 'faint', 'blackout'] },
    { label: 'Unconscious', keywords: ['unconscious', 'knocked out', 'not responsive', 'unresponsive'] },
    { label: 'Reduced Conscious Level', keywords: ['reduced consciousness', 'drowsy', 'rcl', 'low gcs'] },

    { label: 'Seizure', keywords: ['seizure', 'fit', 'fitting', 'convulsion'] },
    { label: 'Stroke Symptoms', keywords: ['stroke', 'fast', 'facial droop', 'slurred speech', 'arm weakness'] },

    { label: 'Headache', keywords: ['headache', 'head pain'] },
    { label: 'Migraine', keywords: ['migraine', 'aura', 'photophobia'] },

    { label: 'Dizziness / Vertigo', keywords: ['dizzy', 'dizziness', 'vertigo', 'spinning'] },
    { label: 'Confusion', keywords: ['confused', 'confusion', 'delirium'] },
    { label: 'Weakness', keywords: ['weak', 'weakness', 'can’t move', "can't move"] },
    { label: 'Speech Difficulty', keywords: ['slurred', 'speech', 'aphasia'] },
  ],

  Medical: [
    { label: 'Abdominal Pain', keywords: ['abdominal', 'tummy', 'stomach pain', 'abdo'] },
    { label: 'Nausea / Vomiting', keywords: ['nausea', 'vomit', 'vomiting', 'sick'] },
    { label: 'Diarrhoea', keywords: ['diarrhoea', 'diarrhea', 'loose stools'] },
    { label: 'Constipation', keywords: ['constipation', 'no bowel movement'] },

    { label: 'Urinary Symptoms (UTI)', keywords: ['uti', 'urine', 'urinary', 'burning urine', 'frequency'] },
    { label: 'Flank Pain', keywords: ['flank', 'kidney', 'renal colic', 'loin pain'] },

    { label: 'Allergic Reaction', keywords: ['allergy', 'allergic', 'hives', 'urticaria'] },
    { label: 'Anaphylaxis', keywords: ['anaphylaxis', 'anaphylactic', 'throat swelling', 'epipen', 'epipen'] },

    { label: 'Fever / Infection', keywords: ['fever', 'temp', 'infection', 'hot', 'rigors'] },
    { label: 'Sepsis Concern', keywords: ['sepsis', 'infection', 'very unwell', 'rigors'] },

    { label: 'Diabetic Problem', keywords: ['diabetes', 'diabetic', 'hypo', 'hyper', 'blood sugar', 'bm'] },
    { label: 'Hypoglycaemia', keywords: ['hypo', 'low sugar', 'low blood sugar', 'bm low'] },
    { label: 'Hyperglycaemia', keywords: ['hyper', 'high sugar', 'high blood sugar', 'dkA', 'dka'] },

    { label: 'Intoxication', keywords: ['intox', 'drunk', 'alcohol', 'substance'] },
    { label: 'Overdose / Poisoning', keywords: ['overdose', 'od', 'poison', 'poisoning'] },

    { label: 'Medication Issue', keywords: ['medication', 'missed meds', 'side effects', 'reaction'] },
    { label: 'Dehydration', keywords: ['dehydration', 'dry', 'not drinking'] },

    { label: 'Heat Illness', keywords: ['heat', 'heat exhaustion', 'heat stroke', 'overheated'] },
    { label: 'Hypothermia / Cold Exposure', keywords: ['hypothermia', 'cold', 'exposure'] },

    { label: 'General Unwell (Adult)', keywords: ['unwell', 'off legs', 'generally unwell', 'weak'] },
    { label: 'General Unwell (Child)', keywords: ['unwell child', 'paeds', 'peds', 'child unwell'] },

    // Pain split (keep non-specific)
    { label: 'Pain (Non-specific)', keywords: ['pain', 'ache'] },
    { label: 'Back Pain', keywords: ['back pain', 'back'] },
    { label: 'Limb Pain', keywords: ['limb pain', 'arm pain', 'leg pain', 'joint pain'] },
    { label: 'Neck Pain', keywords: ['neck pain', 'neck'] },

    { label: 'Vomiting Blood / Suspected GI Bleed', keywords: ['haematemesis', 'hematemesis', 'vomiting blood', 'gi bleed'] },
    { label: 'Rectal Bleeding', keywords: ['pr bleed', 'rectal bleeding', 'blood in stool'] },

    { label: 'Flu-like Symptoms', keywords: ['flu', 'flu-like', 'aches', 'chills'] },
    { label: 'Fatigue / Lethargy', keywords: ['fatigue', 'tired', 'lethargy', 'lethargic'] },
  ],

  'Mental Health': [
    { label: 'Mental Health Problem', keywords: ['mental health', 'mh'] },
    { label: 'Anxiety / Panic', keywords: ['anxiety', 'panic', 'panic attack', 'hyperventilation'] },
    { label: 'Depression', keywords: ['depression', 'low mood'] },
    { label: 'Suicidal Ideation', keywords: ['suicidal', 'si', 'wants to die'] },
    { label: 'Self-Harm', keywords: ['self harm', 'self-harm', 'sh', 'cutting'] },
    { label: 'Behavioural Disturbance', keywords: ['agitated', 'aggression', 'behaviour', 'violent'] },
    { label: 'Acute Psychosis', keywords: ['psychosis', 'hallucinations', 'paranoia'] },
  ],

  'Obstetric & Gynaecological': [
    { label: 'Pregnancy-Related Issue', keywords: ['pregnant', 'pregnancy'] },
    { label: 'Labour', keywords: ['labour', 'labor', 'contractions', 'waters broken'] },
    { label: 'Vaginal Bleeding', keywords: ['pv bleed', 'vaginal bleeding', 'bleeding pregnant'] },
    { label: 'Miscarriage', keywords: ['miscarriage', 'pregnancy loss'] },
    { label: 'Postpartum Problem', keywords: ['postpartum', 'after birth', 'postnatal'] },
    { label: 'Pelvic Pain', keywords: ['pelvic pain', 'lower abdo'] },
  ],

  'ENT / Eye / Skin': [
    { label: 'Eye Problem', keywords: ['eye', 'vision', 'visual'] },
    { label: 'Ear Problem', keywords: ['ear', 'hearing', 'earache'] },
    { label: 'Nosebleed (Epistaxis)', keywords: ['nosebleed', 'epistaxis'] },
    { label: 'Sore Throat', keywords: ['sore throat', 'throat'] },
    { label: 'Dental Problem', keywords: ['dental', 'toothache', 'tooth'] },

    { label: 'Rash', keywords: ['rash', 'hives', 'urticaria'] },
    { label: 'Skin Infection', keywords: ['cellulitis', 'skin infection', 'red hot swollen'] },
    { label: 'Wound Care / Dressing', keywords: ['dressing', 'wound care', 'change dressing'] },
  ],

  Other: [
    // No complaint / assist only
    { label: 'No Medical Complaint', keywords: ['no complaint', 'no medical complaint', 'no issue'] },
    { label: 'Assist Only / Lift Assist', keywords: ['assist', 'lift assist', 'help up', 'falls assist'] },

    // Admin / workflow
    { label: 'Patient Transfer Only', keywords: ['transfer', 'pts', 'transport'] },
    { label: 'Prescription Request', keywords: ['prescription', 'repeat prescription', 'meds request'] },

    // Safety / welfare
    { label: 'Safeguarding Concern', keywords: ['safeguarding', 'abuse', 'neglect'] },
    { label: 'Welfare Check', keywords: ['welfare', 'check', 'concern for welfare'] },

    { label: 'Other', keywords: ['other'] },
    { label: 'Unknown', keywords: ['unknown', 'unk'] },
  ],
}

export default presentingComplaintOptions